import { useModuleBEM } from "@b2bportal/core-themes";
import {
  RebookFlightSegment,
  RebookSliceHeader,
  RebookSliceOrigin,
  useRebookFlightSlice,
} from "@tenant/flights-rebook";
import clsx from "clsx";
import defaultStyles from "./RebookFlightSlice.module.scss";
import type { RebookFlightSliceProps } from "./types";
import { CoreFlightsRebookComponent } from "~core-flights-rebook/components/rebook-component";
import { useFlightsRebookStyles } from "~core-flights-rebook/styles";

const COMPONENT_KEY = CoreFlightsRebookComponent.RebookFlightSlice;

export const RebookFlightSlice = (props: RebookFlightSliceProps) => {
  const { className, children, slice, segments, travelersCount } = props;
  const styles = useFlightsRebookStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context } = useRebookFlightSlice(props);

  return (
    <div className={clsx(block, className)}>
      <RebookSliceHeader
        slice={slice}
        className={cn("flight-route")}
        airports={context.airports}
        travelersCount={travelersCount}
      />

      <div className={cn("slice")}>
        <RebookSliceOrigin
          className={cn("slice-title")}
          slice={slice}
          airports={context.airports}
        />

        {segments.map(({ id, segment, route }) => (
          <RebookFlightSegment
            key={id}
            slice={slice}
            className={cn("segment")}
            segment={segment}
            route={route}
            segmentId={id}
            airports={context.airports}
            airlines={context.airlines}
            direction={context.direction}
          />
        ))}
      </div>
      {children}
    </div>
  );
};
